import { render, staticRenderFns } from "./Sent.vue?vue&type=template&id=1a7e590c&scoped=true&"
import script from "./Sent.vue?vue&type=script&lang=js&"
export * from "./Sent.vue?vue&type=script&lang=js&"
import style0 from "./Sent.vue?vue&type=style&index=0&id=1a7e590c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a7e590c",
  null
  
)

export default component.exports